<template>
	<v-container>
      <v-layout>
        <v-flex xs12 sm10 md8 lg6>
          <v-card>
            <v-alert
              :value="alertInput"
              type="error"
            >
            {{errorMessage}}
            </v-alert>
            <v-toolbar card :color="cr.colorName" prominent>
               <v-toolbar-title class="body-3 white--text">{{formTitle}}
                <v-icon class="pl-2" color="white">add_circle</v-icon>
              </v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
              <v-container>
                <template v-if='bulk'>
                <v-alert
                  v-model="alert"
                  dismissible
                  type="warning"
                >
                  You are about to edit multiple items. Please make sure you know the fields you going to modify
                </v-alert></template>
                  <v-form ref='form'>
                    <v-layout row>
                      <v-flex>
                        <v-text-field
                          label="Title"
                          hint= "Title of the graphic"
                          :error-messages="errors.collect('title')"
                          v-validate="'required|max:50'"
                          data-vv-name="title"
                          required
                          persistent-hint
                          v-model="title"></v-text-field>
                        </v-flex>
                      </v-layout>
                      <v-layout row>
                        <v-flex>
                          <v-text-field
                            label="Case Number"
                            hint= "Usually 1,2,3... etc "
                            v-validate="'required|max:5|numeric'"
                            data-vv-name='caseNum'
                            required
                            persistent-hint
                            :error-messages="errors.collect('caseNum')"
                            v-model="caseNum"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                      <v-layout row>
                        <v-flex>
                          <v-text-field
                            label="Job Number"
                            hint= "Example 15-0963"
                            v-validate="'required|max:7|regex:[0-9]+\-[0-9]+'"
                            :error-messages="errors.collect('jobNum')"
                            data-vv-name="jobNum"
                            required
                            persistent-hint
                            v-model="jobNum"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                      <v-layout row>
                        <v-flex>
                            <v-menu
                                ref='menu'
                                  lazy
                                  :close-on-content-click="false"
                                  v-model="menu"
                                  transition="scale-transition"
                                  offset-y
                                  full-width
                                  :nudge-right="40"
                                  max-width="290px"
                                  min-width="290px">
                                <v-text-field
                                  slot="activator"
                                  label="Last Update (REQUIRED)"
                                  v-model="date"
                                  prepend-icon="event"
                                  hint= "Date map was updated (required**)"
                                  persistent-hint
                                ></v-text-field>
                                <v-date-picker v-model="date" no-title scrollable>
                                   <v-spacer></v-spacer>
                                    <v-btn  color="primary" class="white--text" @click="$refs.menu.save(date)">OK</v-btn>
                                    <v-btn  color="primary" class="white--text"
                                     @click="menu = false">Cancel</v-btn>
                                </v-date-picker>
                            </v-menu>
                          </v-flex>
                        </v-layout>
                         <v-layout row>
                            <v-flex mt-4>
                              <v-textarea
                                label="Notes"
                                hint= "Notes: about active content"
                                persistent-hint
                                outline
                                v-model = "notes"
                                :error-messages="errors.collect('notes')"
                                v-validate="'max:500'"
                                data-vv-name="notes"
                                > 
                            </v-textarea>
                          </v-flex>
                        </v-layout>
                        <v-layout row>
                          <v-flex>
                              <v-menu
                                  lazy
                                  ref="menuDateCreated"
                                  :close-on-content-click="false"
                                  v-model="menuDateCreated"
                                  transition="scale-transition"
                                  :return-value.sync="postby"
                                  offset-y
                                  full-width
                                  :nudge-right="40"
                                  max-width="290px"
                                  min-width="290px"
                                  required
                                  >
                                <v-text-field
                                  slot="activator"
                                  label="Post By"
                                  v-model="postby"
                                  prepend-icon="event"
                                  hint= "Post content by this date. You can leave it blank if YOU ARE NOT ADDING NEW CONTENT"
                              persistent-hint
                                ></v-text-field>
                                <v-date-picker v-model="postby" no-title scrollable actions required>
                                  <v-spacer></v-spacer>
                                    <v-btn  color="primary" class="white--text" @click="$refs.menuDateCreated.save(postby)">OK</v-btn>
                                    <v-btn  color="primary" class="white--text"
                                    @click="menuDateCreated = false">Cancel</v-btn>
                                </v-date-picker>
                              </v-menu>
                            </v-flex>
                        </v-layout>
                        <v-layout row>
                          <v-flex>
                            <v-select
                                v-bind:items="status"
                                v-model="selected"
                                label="Status"
                                input="selected"
                                class="input-group--focused"
                                item-value="text"
                                :hint= "selectHint"
                                 persistent-hint
                                 :error-messages="errors.collect('selected')"
                                v-validate="'required'"
                                required
                                data-vv-name="selected"
                              ></v-select>
                            </v-flex>
                          </v-layout>
                           <v-layout row>
                            <v-flex>
                                <v-text-field
                            label="Case Direction"
                            hint= "Example: Left, Right, Middle...etc"
                            :error-messages="errors.collect('direction')"
                            v-validate="'max:15|regex:[a-zA-Z]+'"
                            data-vv-name="direction"
                            persistent-hint
                            v-model="direction"
                            ></v-text-field>
                            </v-flex>
                          </v-layout>
                          <v-layout row>
                            <v-flex mt-4>
                              <v-btn class="white--text"  :color="cr.colorName" @click="validate()">Save <v-icon class="pl-1" color='white'>check_circle</v-icon></v-btn>
                              <v-btn  class="white--text" :color="cr.colorName" @click="cancel">Cancel<v-icon class="pl-1" color='white'>cancel</v-icon></v-btn>
                            </v-flex>
                          </v-layout>
                  </v-form>
              </v-container>
            </v-card-text>
           </v-card>
        </v-flex>
      </v-layout>
    </v-container>
</template>
<script>
  import {bus} from '../../main'
  import {mapGetters} from 'vuex'
  export default {
    props: {
      edit: {
        type: Object
      },
      add: {
        type: Boolean
      },
      hide: {
        type: Boolean
      },
      search: {},
      bulk: {
        type: Boolean
      },
      addData: {
        type: Object
      },
      cr: {
        type: Object
      }
    },
    data () {
      return {
        alert: true,
        errorMessage: '',
        notes: '',
        postby: '',
        alertInput: false,
        direction: '',
        formTitle: 'Add Map',
        iconTitle: 'add_circle',
        caseNum: '',
        menuDateCreated: false,
        jobNum: '',
        menu: false,
        title: '',
        date: null,
        selected: '',
        serial: '',
        status: ['Active', 'Expired', 'Revision', 'Pending'],
        selectHint: 'Status of the display',
        openCloseForms: {
          edit: false,
          add: false,
          search: false
        },
        dataToSave: '',
        bulkEdit: {
          caseNum: '',
          title: '',
          jobNum: '',
          date: '',
          serialCode: '',
          status: '',
          caseDirection: ''
        },
        prevSerialCode: ''
      }
    },
    computed: {
      ...mapGetters({currentUser: 'currentUser'})
    },
    watch: {
      edit (ve) {
        this.formTitle = 'Edit insert'
        this.iconTitle = 'edit'
        this.title = ve.title
        this.caseNum = ve.caseNum
        this.jobNum = ve.jobNum
        this.postby = ve.postby
        this.notes = ve.notes
        this.date = ve.date
        this.selected = ve.status
        this.selectHint = 'Please choose "' + ve.status + '" Its the current value unless you want to change it :)'
        this.serial = ve.serialCode
        this.direction = ve.caseDirection
        this.openCloseForms.edit = true
        this.openCloseForms.add = false
        this.openCloseForms.search = false
        this.$validator.reset()
      },
      add () {
        this.openCloseForms.edit = false
        this.openCloseForms.add = true
        this.openCloseForms.search = false
        this.$validator.reset()
      },
      search () {
        this.formTitle = 'Edit Insert'
        this.iconTitle = 'edit'
        this.openCloseForms.edit = false
        this.openCloseForms.add = false
        this.openCloseForms.search = true
        this.$validator.reset()
        var obj = this.search
        if (obj.length > 1) {
          this.bulkEdit = {
            caseNum: '',
            title: '',
            jobNum: '',
            date: '',
            status: '',
            caseDirection: '',
            notes: '',
            postby: ''
          }
          this.resetValues()
        } else {
          this.title = obj[0].title
          this.caseNum = obj[0].caseNum
          this.jobNum = obj[0].jobNum
          this.date = obj[0].date
          this.notes = obj[0].notes
          this.postby = obj[0].postby
          this.selectHint = 'Please choose "' + obj[0].status + '" Its the current value unless you want to change it :)'
          this.direction = obj[0].caseDirection
        }
      }
    },
    methods: {
      validate () {
        if (this.openCloseForms.search) {
          this.save()
        } else {
          this.$validator.validateAll().then((results) => {
            if (results) {
              this.save()
            } else {
              this.alertInput = true
              this.errorMessage = 'Something went Wrong!! Please check the fields and try again!'
              setTimeout(() => {
                this.alertInput = false
              }, 5000)
            }
          })
        }
      },
      save () {
        var vm = this
        if (vm.openCloseForms.edit) { // edit map
          vm.dataToSave = {
            obj: {
              caseNum: vm.caseNum,
              title: vm.title,
              jobNum: vm.jobNum,
              date: vm.date,
              serialCode: vm.addData.code,
              status: vm.selected,
              caseDirection: vm.direction,
              mapDisplayId: vm.addData.displayId.toString(),
              displayFk: vm.addData.displayId,
              notes: vm.notes,
              postby: vm.postby
            },
            userFk: vm.currentUser.id,
            map_id: vm.edit.id,
            did: vm.addData.id,
            rline: vm.cr.name,
            portal: vm.addData.portal_name
          }
          if (vm.selected === 'Pending') {
            vm.dataToSave.obj.install_date = null
            vm.dataToSave.obj.qc_date = null
            vm.dataToSave.obj.isInstall = 'No'
          }
          vm.$http.post('/mapsdata/map/editmap', vm.dataToSave)
          .then(function (response) {
            bus.$emit('closeForm', vm.openCloseForms)
            bus.$emit('saveForm', true)
          })
        }
        if (vm.openCloseForms.add) { // add map
          vm.$validator.reset()
          vm.dataToSave = {
            obj: {
              caseNum: vm.caseNum,
              title: vm.title,
              jobNum: vm.jobNum,
              date: vm.date === '' || vm.date === undefined ? null : vm.date,
              serialCode: vm.addData.code,
              status: vm.selected,
              caseDirection: vm.direction,
              mapDisplayId: vm.addData.displayId.toString(),
              displayFk: vm.addData.displayId,
              isInstall: 'No',
              notes: vm.notes,
              postby: vm.postby === '' || vm.postby === undefined ? null : vm.postby // set to null just in case user does not picked a date
            },
            userFk: vm.currentUser.id,
            did: vm.addData.id,
            rline: vm.cr.name,
            portal: vm.addData.portal_name
          }
          vm.$http.post('/mapsdata/map/createmap', vm.dataToSave)
           .then(function (response) {
             vm.$refs.form.reset()
             bus.$emit('closeForm', vm.openCloseForms)
             bus.$emit('saveForm', true)
           })
        }
        if (vm.openCloseForms.search) {
          if (vm.search.length !== 1) {
            var results = []
            var obj = {
              code: '',
              editObj: ''
            }
            for (var i = 0; i < vm.search.length; i++) {
              vm.bulkEdit.caseNum = vm.caseNum === '' ? vm.search[i].caseNum : vm.caseNum
              vm.bulkEdit.title = vm.title === '' ? vm.search[i].title : vm.title
              vm.bulkEdit.jobNum = vm.jobNum === '' ? vm.search[i].jobNum : vm.jobNum
              vm.bulkEdit.date = vm.date === '' || vm.date === null ? vm.search[i].date : vm.date
              vm.bulkEdit.status = vm.selected === '' ? vm.search[i].status : vm.selected
              vm.bulkEdit.caseDirection = vm.direction === '' ? vm.search[i].caseDirection : vm.direction
              vm.bulkEdit.mapDisplayId = vm.search[i].displayFk
              vm.bulkEdit.notes = vm.notes === '' ? vm.search[i].notes : vm.notes
              vm.bulkEdit.postby = vm.postby === '' ? vm.search[i].postby : vm.postby
              vm.bulkEdit.displayFk = vm.search[i].displayFk // parseInt(vm.search[i].display_id)
              vm.bulkEdit.userFk = vm.currentUser.id
              vm.bulkEdit.did = vm.search[i].display_id
              vm.bulkEdit.rline = vm.search[i].rail.split('-')[1]
              vm.bulkEdit.map_id = vm.search[i].id
              vm.bulkEdit.portal = vm.search[i].station_name
              obj.code = vm.search[i].serialCode
              obj.editObj = vm.bulkEdit
              if (vm.selected === 'Pending') {
                obj.editObj.install_date = null
                obj.editObj.qc_date = null
                obj.editObj.isInstall = 'No'
              }
              results.push(obj)
              obj = {
                code: '',
                editObj: ''
              }
              vm.bulkEdit = {}
            }
            vm.$http.post('/mapsdata/map/bulkEdit', results)
            .then(function (response) {
              vm.$store.dispatch('closeForm')
              bus.$emit('saveSearchEdit', response.data.msg)
            })
          } else {
            vm.dataToSave = {
              obj: {
                caseNum: vm.caseNum === '' ? vm.search[0].caseNum : vm.caseNum,
                title: vm.title === '' ? vm.search[0].title : vm.title,
                jobNum: vm.jobNum === '' ? vm.search[0].jobNum : vm.jobNum,
                date: vm.date === null || vm.date === '' ? vm.search[0].date : vm.date,
                serialCode: vm.search[0].serialCode,
                notes: vm.notes === '' ? vm.search[0].notes : vm.notes,
                status: vm.selected === '' ? vm.search[0].status : vm.selected,
                caseDirection: vm.direction === '' ? vm.search[0].caseDirection : vm.direction,
                mapDisplayId: vm.search[0].displayFk,
                displayFk: vm.search[0].displayFk,
                postby: vm.postby === null ? vm.search[0].postby : vm.postby
              },
              userFk: vm.currentUser.id,
              did: vm.search[0].display_id,
              rline: vm.search[0].rail.split('-')[1],
              map_id: vm.search[0].id,
              portal: vm.search[0].station_name
            }
            if (vm.selected === 'Pending') {
              vm.dataToSave.obj.install_date = null
              vm.dataToSave.obj.qc_date = null
              vm.dataToSave.obj.isInstall = 'No'
            }
            vm.$http.post('/mapsdata/map/editmap', vm.dataToSave)
            .then(function (response) {
              vm.$store.dispatch('closeForm')
              bus.$emit('saveSearchEdit', response.data.msg)
            })
          }// end else
        }
      },
      resetValues () {
        this.caseNum = ''
        this.title = ''
        this.jobNum = ''
        this.date = null
        this.serialCode = ''
        this.selected = ''
        this.caseDirection = ''
        this.notes = ''
        this.postby = ''
      },
      cancel () {
        if (this.openCloseForms.edit) {
          this.$validator.reset()
          bus.$emit('closeForm', this.openCloseForms, this.edit)
        }
        if (this.openCloseForms.add) {
          this.$validator.reset()
          this.$refs.form.reset()
          bus.$emit('closeForm', this.openCloseForms)
        }
        if (this.openCloseForms.search) {
          this.$validator.reset()
          this.$store.dispatch('closeForm')
        }
      }
    }
  }
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/Forms/AddMap.vue